import React from 'react';
import { wire } from 'react-hot-wire';
import BattlesService from 'services/battles/BattlesService';
import useGetMyBattlePlayerStatus from '../../hook/api/useGetMyBattlePlayerStatus';
import CurrentStatus from './CurrentStatus';
import { FormattedMessage } from 'react-intl';

export type MyStatusProps = {};
export type MyStatusWiredProps = MyStatusProps & {
	'services.battlesService': BattlesService;
};

export const MyStatus = ({ ...props }: MyStatusWiredProps) => {
	const { data, isFetching, refetch } = useGetMyBattlePlayerStatus(props);

	return (
		<div className="d-flex flex-row flex-grow-1 battlePlayerMyStatus justify--end">
			<div className="mr-2 color--gray">
				<FormattedMessage id="battles.status.my" />
			</div>
			<div>
				{isFetching || !data ? (
					<p className="placeholder-glow">
						<span className="placeholder"></span>
					</p>
				) : (
					<CurrentStatus
						{...props}
						type={data.currentStatus}
						inactiveUntil={data.inactiveUntil}
						onChange={() => refetch()}
					/>
				)}
			</div>
		</div>
	);
};

export default wire<MyStatusWiredProps, MyStatusProps>(['services.battlesService'], MyStatus);
